import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { Outlet } from 'react-router-dom';

const EmbedLayout = () => {
  return (
    <div className="container-fluid">
      <Row className="py-3" md={12}>
        <Col>
          <Outlet />
        </Col>
      </Row>
    </div>
  );
};

EmbedLayout.propTypes = {
  match: PropTypes.object
};

export default EmbedLayout;
